<script setup>
import Card from '@/components/shared/page/Card.vue'
import Avatar from '@/components/shared/core/Avatar.vue'
import EnrollmentBadge from '@/components/enrollments/EnrollmentBadge.vue'
import {Enrollment} from '@/models/enrollment.model.js'
import {toRefs, computed} from 'vue'

//Emits and props
defineEmits([
  'click',
])
const props = defineProps({
  enrollment: {
    type: Enrollment,
    required: true,
  },
})

//Refs
const {enrollment} = toRefs(props)
const channel = computed(() => enrollment.value.channel)

//Header and subheader
const header = computed(() => {
  if (channel.value) {
    return channel.value.name
  }
  return enrollment.value.displayName
})
const subheader = computed(() => {
  if (channel.value) {
    return enrollment.value.displayName
  }
  return enrollment.value.statusText
})
</script>

<template>
  <Card
    is-clickable
    tabindex="0"
    :header="header"
    :subheader="subheader"
    :preview="enrollment.lastMessagePreview || 'No messages yet'"
    :timestamp="enrollment.lastMessageSentAt"
    :show-dot="enrollment.isUnread && !enrollment.hasEnded"
    @click="$emit('click', $event)"
    @keydown.enter="$emit('click', $event)"
    @keydown.space="$emit('click', $event)"
  >
    <template #image>
      <Avatar
        v-if="channel?.signedImageUrl"
        :image="channel?.signedImageUrl"
        :image-alt-text="channel?.name"
        size="large"
      />
      <Avatar
        v-else-if="channel"
        :label="channel.initials"
        size="large"
      />
      <Avatar
        v-else
        :label="enrollment.initials"
        size="large"
      />
    </template>
    <template #badge>
      <EnrollmentBadge :enrollment="enrollment" />
    </template>
  </Card>
</template>
